export default "__VITE_ASSET__ticPaCWP__"